module.exports = __webpack_public_path__ + "static/media/face.f79a1aa9.png";